import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
import { FileSpreadsheet, Loader2, AlertCircle, Check } from 'lucide-vue-next';
import { route } from 'ziggy-js';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceExportButton',
    props: {
        filters: { type: Object, required: false },
        dataTrack: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const isLoading = ref(false);
        const isSuccess = ref(false);
        const errorMessage = ref(null);
        let successTimer = null;
        // Constructs full download URL with query params
        const buildDownloadUrl = () => {
            const url = new URL(route('invoice.download.route'), window.location.origin);
            const filters = props.filters || {};
            // Append array parameters (e.g. brand_ids[]=1&brand_ids[]=2)
            if (filters.brand_ids?.length) {
                filters.brand_ids.forEach((id) => url.searchParams.append('brand_ids[]', String(id)));
            }
            if (filters.statuses?.length) {
                filters.statuses.forEach((status) => url.searchParams.append('statuses[]', status));
            }
            // Append standard single-value parameters
            const directParams = {
                due_date_from: filters.due_date_from,
                due_date_to: filters.due_date_to,
                created_from: filters.created_from,
                created_to: filters.created_to,
                graphic_artist_id: filters.graphic_artist_id,
                aging_bucket: filters.aging_bucket,
                po_filter: filters.po_filter,
                sort: filters.sort || '',
            };
            for (const key in directParams) {
                const val = directParams[key];
                if (val !== undefined && val !== null && val !== '') {
                    url.searchParams.set(key, String(val));
                }
            }
            return url.toString();
        };
        const triggerDownload = async () => {
            isLoading.value = true;
            errorMessage.value = null;
            isSuccess.value = false;
            if (successTimer) {
                clearTimeout(successTimer);
                successTimer = null;
            }
            try {
                const downloadUrl = buildDownloadUrl();
                // Send the HTTP request - don't use axios for this it doesn't handle error blob well
                const response = await fetch(downloadUrl, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                });
                const contentType = response.headers.get('Content-Type') || '';
                // Check if server returned an error (HTTP 4xx/5xx OR JSON error payload)
                if (!response.ok || contentType.includes('application/json')) {
                    const json = await response.json().catch(() => ({}));
                    if (json.error === 'too_large') {
                        errorMessage.value = 'too_large';
                    }
                    else {
                        errorMessage.value = 'error';
                    }
                    return;
                }
                // Convert file response into a blob link and click it
                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                const today = new Date().toLocaleDateString('sv-SE'); // Formats YYYY-MM-DD
                // Create temporary <a> tag to trigger browser "Save File" prompt
                const anchor = document.createElement('a');
                anchor.href = objectUrl;
                anchor.download = `Invoices_${today}.xlsx`;
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();
                // Cleanup memory
                setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
                // Show success state on the button
                isSuccess.value = true;
                successTimer = setTimeout(() => {
                    isSuccess.value = false;
                }, 3000);
            }
            catch (err) {
                errorMessage.value = 'error';
            }
            finally {
                isLoading.value = false;
            }
        };
        watch(() => props.filters, () => {
            errorMessage.value = null;
        }, { deep: true });
        const __returned__ = { props, isLoading, isSuccess, errorMessage, get successTimer() { return successTimer; }, set successTimer(v) { successTimer = v; }, buildDownloadUrl, triggerDownload, get FileSpreadsheet() { return FileSpreadsheet; }, get Loader2() { return Loader2; }, get AlertCircle() { return AlertCircle; }, get Check() { return Check; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
